module.exports = __webpack_public_path__ + "img/sLD_Token_voucher_80k_eth.6a945d48.png";